<template>
    <div class="mb-5">
        <div class="input-group custom mb-3">
            <input type="text"
                   v-model="str"
                   :placeholder="tSearchPlaceholder"
                   @input="search"
            >
            <span class="input-icon">
               <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                    :style="{verticalAlign: 'baseline'}"
                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 250.313 250.313" style="enable-background:new 0 0 250.313 250.313;"
                    xml:space="preserve">
                    <g id="Search">
                        <path :fill="shopColor"
                              style="fill-rule:evenodd;clip-rule:evenodd;"
                              d="M244.186,214.604l-54.379-54.378c-0.289-0.289-0.628-0.491-0.93-0.76
                            c10.7-16.231,16.945-35.66,16.945-56.554C205.822,46.075,159.747,0,102.911,0S0,46.075,0,102.911
                            c0,56.835,46.074,102.911,102.91,102.911c20.895,0,40.323-6.245,56.554-16.945c0.269,0.301,0.47,0.64,0.759,0.929l54.38,54.38
                            c8.169,8.168,21.413,8.168,29.583,0C252.354,236.017,252.354,222.773,244.186,214.604z M102.911,170.146
                            c-37.134,0-67.236-30.102-67.236-67.235c0-37.134,30.103-67.236,67.236-67.236c37.132,0,67.235,30.103,67.235,67.236
                            C170.146,140.044,140.043,170.146,102.911,170.146z"/>
                    </g>
                </svg>
            </span>
        </div>

        <div class="row d-lg-none mb-4">
            <div class="col-12 col-md-6">
                <a class="btn-orange btn-collapse"
                   data-toggle="collapse"
                   href="#collapseShopsSidebar"
                   role="button"
                   aria-expanded="false"
                   aria-controls="_first-menu"
                   @click="categoriesAreVisibleForMobile = !categoriesAreVisibleForMobile"
                >
                    {{tShowCategories}}
                </a>
            </div>
            <div class="col-12 col-md-6">
                <a :href="backBtnLink"
                   class="btn-orange">{{backBtnTitle}}</a>
            </div>
        </div>
        <div class="collapse multi-collapse d-lg-block" :class="{ 'visible': categoriesAreVisibleForMobile }">

            <!--<h4 class="mb-3">{{tCategoriesTitle}}</h4>-->
            <h4 class="mb-3">{{ tShopsTitle }}</h4>

            <div class="form-check custom"
                 :key="category.id"
                 v-for="category in categories">
                <input type="checkbox"
                       :id="'categoryCheckbox'+category.id"
                       class="form-check-input"
                       @change="checkCategory(category.id)"
                       :value="category.id">
                <label class="form-check-label cursor-pointer"
                       :for="'categoryCheckbox'+category.id">{{category.name}}</label>
            </div>
        </div>

      <div class="collapse multi-collapse d-lg-block" :class="{ 'visible': categoriesAreVisibleForMobile }">

        <!--<h4 class="mb-3">{{tCategoriesTitle}}</h4>-->
        <h4 class="mb-3">{{ tServicesTitle }}</h4>

        <div class="form-check custom"
             :key="service.id"
             v-for="service in services">
          <input type="checkbox"
                 :id="'serviceCheckbox'+service.id"
                 class="form-check-input"
                 @change="checkCategory(service.id)"
                 :value="service.id">
          <label class="form-check-label cursor-pointer"
                 :for="'serviceCheckbox'+service.id">{{service.name}}</label>
        </div>
      </div>

      <div class="collapse multi-collapse d-lg-block" :class="{ 'visible': categoriesAreVisibleForMobile }">

        <!--<h4 class="mb-3">{{tCategoriesTitle}}</h4>-->
        <h4 class="mb-3">{{ tFoodsTitle }}</h4>

        <div class="form-check custom"
             :key="food.id"
             v-for="food in foods">
          <input type="checkbox"
                 :id="'serviceCheckbox'+food.id"
                 class="form-check-input"
                 @change="checkCategory(food.id)"
                 :value="food.id">
          <label class="form-check-label cursor-pointer"
                 :for="'serviceCheckbox'+food.id">{{food.name}}</label>
        </div>
      </div>
    </div>
</template>

<script>
  import * as AppConfig from '@/config/AppConfig'

  import {mapActions} from 'vuex'

  export default {
    name: 'SearchSidebar',
    data () {
      return {
        shopColor: AppConfig.SHOP_COLOR,
        tSearchPlaceholder: AppConfig.T_SEARCH_PLACEHOLDER,
        tShowCategories: AppConfig.T_SHOW_CATEGORIES,
        backBtnTitle: AppConfig.T_BACK_BTN,
        backBtnLink: AppConfig.BACK_BTN_LINK,
        tOrderBy: AppConfig.T_ORDER_BY,
        tCategoriesTitle: AppConfig.T_CATEGORIES,
        tShopsTitle: AppConfig.T_SHOPS,
        tServicesTitle: AppConfig.T_SERVICES,
        tFoodsTitle: AppConfig.T_FOODS,
        orderByValues: AppConfig.ORDER_BY_VALUES,
        orderBy: null,
        str: '',
        categoriesAreVisibleForMobile: false,
        selectedCategories: []
      }
    },
    computed: {
      categories () {
        return this.$store.getters.getStoreVar('categories')
      },
      services () {
        return this.$store.getters.getStoreVar('services')
      },
      foods () {
        return this.$store.getters.getStoreVar('foods')
      }
    },
    methods: {
      ...mapActions(['getCategories', 'getServices', 'getFoods', 'setStoreVar']),
      search ($event) {
        this.$emit('search', $event.target.value)
      },
      checkCategory (id) {
        this.categoriesAreVisibleForMobile = false
        !this.selectedCategories.includes(id) ? this.selectedCategories.push(id) : this.selectedCategories = this.selectedCategories.filter(category => id !== category)
        this.$emit('category', this.selectedCategories)
      }
    },
    created () {
      this.getCategories()
      this.getServices()
      this.getFoods()
    }
  }
</script>

<style scoped>
    .cursor-pointer {
        cursor: pointer;
    }
  h4 {
    margin-top: 20px;
  }
  .btn-collapse {
    margin-bottom: 20px;
  }
  .collapse {
    width: 100%;
  }
  .collapse.visible {
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/SearchSidebar.vue